import React from "react";
import logger from "logger";
import TaskDialog from "TaskDialogCommon/TaskDialog";

const downloadReport = (items, filename) => {
  const element = document.createElement("a");
  let content = "";
  items.forEach((item) => {
    content += item.itemname + "\t" + item.itemcount + "\n";
  });
  const file = new Blob([content], {
    type: "text/plain",
  });
  element.href = URL.createObjectURL(file);
  element.download = filename + ".txt";
  document.body.appendChild(element); // Required for this to work in FireFox
  element.click();
};

export default function(props) {
  const { items, heading } = props;
  return (
    <TaskDialog heading={heading} fullScreen={true}>
      {items &&
        items.map((item) => {
          return (
            <div
              style={{ display: "flex", maxWidth: "300px", margin: "0 auto" }}
            >
              <span>{`${item.itemname}: `}</span>
              <span style={{ flex: "1" }} />
              <span>{`${item.itemcount}`}</span>
            </div>
          );
        })}
      <button
        onClick={() => {
          downloadReport(items, heading);
        }}
      >
        Download as file
      </button>
    </TaskDialog>
  );
}
